module.exports = "/assets/animacja-baner.gif?6Wc6XJs";